/* eslint-disable */
import axios from 'axios'
import md5 from 'js-md5'
import { Base64 } from 'js-base64'
import { getQuery, getSessionKey } from '../assets/js/util'
import { Toast } from 'vant'
import Loading from 'muse-ui-loading'
import { getToken, removeSessionKey } from '../assets/js/util'
import { isWeXin } from '../assets/js/tools'
import router from '../routes/index'

//Toast的配置
let opt = {
    position: 'bottom', // 弹出的位置
    time: 3000, // 显示的时长
    closeIcon: 'close', // 关闭的图标
    close: true, // 是否显示关闭按钮
    successIcon: 'check_circle', // 成功信息图标
    infoIcon: 'info', // 信息信息图标
    warningIcon: 'priority_high', // 提醒信息图标
    errorIcon: 'warning' // 错误信息图标
}

function httpRequest(options) {
    this.options = {
        // 默认POST
        method: 'post',
        // 请求url
        url: '',
        // 请求body
        data: {},
        // 是否loading
        loading: true,
        // 是否提示错误信息
        errorMsg: true,
        // 是否混入query信息
        mixnisQuery: false,
        ...options
    }

    this.loading = null
    this.axios = null

    this.init = () => {
        // const token = localStorage.getItem('token') || '';
        const token = getToken() || ''
        const timestamp = parseInt(+new Date() / 1000, 10)
        const conf = {
            baseURL: process.env.VUE_APP_API,
            timeout: 20000,
            headers: {
                // timestamp,
                // token,
                'Content-Type': 'multipart/form-data'
            },
            transformRequest: [
                function (data) {
                    let formData = new FormData()
                    for (let key in data) {
                        if (data.hasOwnProperty(key)) {
                            if (
                                Object.prototype.toString.call(data[key]) === '[object Array]' ||
                                Object.prototype.toString.call(data[key]) === '[object Object]'
                            ) {
                                formData.append(key, JSON.stringify(data[key]))
                            } else {
                                formData.append(key, data[key])
                            }
                        }
                    }
                    return formData
                }
            ]
        }
        this.axios = axios.create(conf)
    }

    this.registerHook = () => {
        if (this.axios) {
            this.axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
            this.axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest'
            this.axios.defaults.responseType = 'json'
            // 添加请求拦截器
            this.axios.interceptors.request.use(
                (config) => {
                    const sessionKey = getSessionKey()
                    // 在发送请求之前做些什么
                    if (this.options.loading) {
                        this.loading = Loading()
                    }
                    // console.log('sessionKey =>', sessionKey)
                    config.params = {
                        ...config.params,
                        sessionKey: sessionKey.sessionKey,
                        userId: sessionKey.userId,
                        t: new Date().getTime()
                    }
                    return config
                },
                (error) => {
                    // 对请求错误做些什么
                    console.log('发送请求之前:错误 ==>>', error)
                    return Promise.reject(error)
                }
            )

            // 添加响应拦截器
            this.axios.interceptors.response.use(
                (response) => {
                    // 对响应数据做点什么
                    if (this.loading) {
                        this.loading.close()
                        this.loading = null
                    }
                    if (response.data.code === 0 || response.config.url === 'user/mp-sign') {
                        return response.data
                    } else if (response.data.code === 3200) {
                        Toast(response.data.msg)
                        router.push({ path: '/', replace: true })
                        return Promise.reject(response.data)
                    } else if (response.data.code === 3001) {
                        // 临时修改
                        // 当前登录已失效
                        // removeSessionKey();
                        // //window.location.reload();
                        // const query = getQuery()
                        // delete query.redirectUrl
                        // let params = []
                        // for (let key in query) {
                        //   if (key && query[key]) {
                        //     params.push(`${key}=${query[key]}`)
                        //   }
                        // }
                        // window.location.href = `/login?redirectUrl=${
                        //   encodeURIComponent(window.location.pathname + '?' + params.join('&'))
                        // }`
                    } else {
                        if (this.options.errorMsg) {
                            Toast(response.data.msg)
                        }
                        return Promise.reject(response.data)
                    }
                },
                (error) => {
                    if (this.loading) {
                        this.loading.close()
                        this.loading = null
                    }
                    // 对响应错误做点什么
                    console.log('响应拦截器:错误 ==>>', error)
                    return Promise.reject(error)
                }
            )
        }
    }

    this.request = () => {
        // 混入query参数
        if (this.options.mixnisQuery) {
            const query = getQuery()
            this.options.data = {
                ...query,
                ...this.options.data
            }
        }

        this.init()
        // 注册钩子
        this.registerHook()

        return this.axios(this.options)
    }
}

function http(obj) {
    return new httpRequest(obj).request()
}

export default http
